module.exports = require("core-js-pure/stable/parse-int");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/parse-int.js
// module id = 612
// module chunks = 0